// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-coordinate-space-transform-widget {
  display: grid;
  justify-items: stretch;
}

.neuroglancer-coordinate-space-transform-widget input {
  font-family: monospace;
  justify-self: stretch;
  background-color: black;
  color: white;
  padding: 2px;
}

.neuroglancer-coordinate-space-transform-widget *[data-will-be-deleted="true"] {
  color: #666;
}

.neuroglancer-coordinate-space-transform-label {
  font-style: italic;
  color: #fcc;
  align-self: center;
}

.neuroglancer-coordinate-space-transform-input-lower-label {
  grid-row: sourceLower;
  grid-column: outputLabel / sourceDim 1;
}

.neuroglancer-coordinate-space-transform-translation-label {
  grid-row: sourceLabel / outputDim 1;
  grid-column: sourceDim -1;
  writing-mode: vertical-lr;
  text-orientation: mixed;
  align-self: end;
  justify-self: center;
  margin-bottom: 2px;
}

.neuroglancer-coordinate-space-transform-input-lower-label,
.neuroglancer-coordinate-space-transform-input-upper-label,
.neuroglancer-coordinate-space-transform-input-scale-label {
  text-align: right;
  margin-right: 4px;
}

.neuroglancer-coordinate-space-transform-input-upper-label {
  grid-row: sourceUpper;
  grid-column: headerStart / headerEnd;
}

.neuroglancer-coordinate-space-transform-input-scale-label {
  grid-row: 5;
  grid-column: headerStart / headerEnd;
}

.neuroglancer-coordinate-space-transform-source-label {
  grid-row: sourceLabel;
  grid-column: sourceDim 1 / sourceDim -1;
  text-align: center;
}

.neuroglancer-coordinate-space-transform-output-label {
  grid-row: outputDim 1 / outputDim -1;
  grid-column: outputLabel;
  writing-mode: vertical-lr;
  text-orientation: mixed;
  align-self: center;
  justify-self: end;
  margin-right: 2px;
}

.neuroglancer-coordinate-space-transform-input-name {
  text-align: center;
}

.neuroglancer-coordinate-space-transform-input-name,
input.neuroglancer-coordinate-space-transform-output-name {
  font-family: monospace;
  color: #ff6;
}

.neuroglancer-coordinate-space-transform-scale {
  text-align: right;
}

.neuroglancer-coordinate-space-transform-input-bounds,
.neuroglancer-coordinate-space-transform-output-bounds {
  white-space: nowrap;
  font-family: monospace;
  font-size: small;
  text-align: right;
  padding-left: 2px;
  padding-right: 2px;
  color: #aff;
}

.neuroglancer-coordinate-space-transform-input-bounds.neuroglancer-coordinate-space-transform-singleton:not(
    *[data-will-be-deleted="true"]
  ) {
  color: #fa6;
}

.neuroglancer-coordinate-space-transform-widget input[data-is-valid="false"],
.neuroglancer-coordinate-space-transform-widget
  input[data-is-valid="false"]::placeholder {
  text-decoration: solid underline red;
}

.neuroglancer-coordinate-space-transform-output-extend {
  grid-row: outputDim -1;
  grid-column: outputNames;
  display: flex;
  flex-direction: column;
}

.neuroglancer-coordinate-space-transform-output-extend input {
  align-self: stretch;
}

.neuroglancer-coordinate-space-transform-output-extend[data-is-active="false"]
  input {
  display: none;
}

.neuroglancer-coordinate-space-transform-output-extend[data-is-active="true"]
  .neuroglancer-icon {
  display: none;
}

.neuroglancer-coordinate-space-transform-output-extend .neuroglancer-icon {
  align-self: start;
}

.neuroglancer-coordinate-space-transform-translation-coeff {
  margin-left: 3px;
}

.neuroglancer-coordinate-space-transform-output-scale-container {
  margin-right: 3px;
}

.neuroglancer-coordinate-space-transform-input-scale-container,
.neuroglancer-coordinate-space-transform-input-scale-label {
  margin-bottom: 3px;
}

.neuroglancer-coordinate-space-transform-widget input,
.neuroglancer-coordinate-space-transform-output-name-container,
.neuroglancer-coordinate-space-transform-scale-container {
  border: 1px solid #333;
}

.neuroglancer-coordinate-space-transform-widget
  .neuroglancer-coordinate-space-transform-output-name,
.neuroglancer-coordinate-space-transform-widget
  .neuroglancer-coordinate-space-transform-scale {
  border: 0px;
}

.neuroglancer-coordinate-space-transform-output-name-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-right: 3px;
}

.neuroglancer-coordinate-space-transform-scale-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.neuroglancer-coordinate-space-transform-scale-suggestion {
  font-family: monospace;
  cursor: pointer;
  border-radius: 20%;
  border: 1px solid #333;
  align-self: flex-end;
  margin: 2px;
  color: #aaa;
}

.neuroglancer-coordinate-space-transform-scale-suggestion svg {
  width: 16px;
  height: 16px;
  fill: transparent;
  stroke: #aaa;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.neuroglancer-coordinate-space-transform-scale-suggestion:hover {
  background-color: #db4437;
  border: 1px solid transparent;
  color: white;
}

.neuroglancer-coordinate-space-transform-scale-suggestion:hover svg {
  stroke: white;
}

.neuroglancer-coordinate-space-transform-widget-reset-buttons {
  grid-row: outputDim -1;
  grid-column: headerEnd / -1;
  justify-self: start;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/widget/coordinate_transform.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB","sourcesContent":["/**\n * @license\n * Copyright 2019 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-coordinate-space-transform-widget {\n  display: grid;\n  justify-items: stretch;\n}\n\n.neuroglancer-coordinate-space-transform-widget input {\n  font-family: monospace;\n  justify-self: stretch;\n  background-color: black;\n  color: white;\n  padding: 2px;\n}\n\n.neuroglancer-coordinate-space-transform-widget *[data-will-be-deleted=\"true\"] {\n  color: #666;\n}\n\n.neuroglancer-coordinate-space-transform-label {\n  font-style: italic;\n  color: #fcc;\n  align-self: center;\n}\n\n.neuroglancer-coordinate-space-transform-input-lower-label {\n  grid-row: sourceLower;\n  grid-column: outputLabel / sourceDim 1;\n}\n\n.neuroglancer-coordinate-space-transform-translation-label {\n  grid-row: sourceLabel / outputDim 1;\n  grid-column: sourceDim -1;\n  writing-mode: vertical-lr;\n  text-orientation: mixed;\n  align-self: end;\n  justify-self: center;\n  margin-bottom: 2px;\n}\n\n.neuroglancer-coordinate-space-transform-input-lower-label,\n.neuroglancer-coordinate-space-transform-input-upper-label,\n.neuroglancer-coordinate-space-transform-input-scale-label {\n  text-align: right;\n  margin-right: 4px;\n}\n\n.neuroglancer-coordinate-space-transform-input-upper-label {\n  grid-row: sourceUpper;\n  grid-column: headerStart / headerEnd;\n}\n\n.neuroglancer-coordinate-space-transform-input-scale-label {\n  grid-row: 5;\n  grid-column: headerStart / headerEnd;\n}\n\n.neuroglancer-coordinate-space-transform-source-label {\n  grid-row: sourceLabel;\n  grid-column: sourceDim 1 / sourceDim -1;\n  text-align: center;\n}\n\n.neuroglancer-coordinate-space-transform-output-label {\n  grid-row: outputDim 1 / outputDim -1;\n  grid-column: outputLabel;\n  writing-mode: vertical-lr;\n  text-orientation: mixed;\n  align-self: center;\n  justify-self: end;\n  margin-right: 2px;\n}\n\n.neuroglancer-coordinate-space-transform-input-name {\n  text-align: center;\n}\n\n.neuroglancer-coordinate-space-transform-input-name,\ninput.neuroglancer-coordinate-space-transform-output-name {\n  font-family: monospace;\n  color: #ff6;\n}\n\n.neuroglancer-coordinate-space-transform-scale {\n  text-align: right;\n}\n\n.neuroglancer-coordinate-space-transform-input-bounds,\n.neuroglancer-coordinate-space-transform-output-bounds {\n  white-space: nowrap;\n  font-family: monospace;\n  font-size: small;\n  text-align: right;\n  padding-left: 2px;\n  padding-right: 2px;\n  color: #aff;\n}\n\n.neuroglancer-coordinate-space-transform-input-bounds.neuroglancer-coordinate-space-transform-singleton:not(\n    *[data-will-be-deleted=\"true\"]\n  ) {\n  color: #fa6;\n}\n\n.neuroglancer-coordinate-space-transform-widget input[data-is-valid=\"false\"],\n.neuroglancer-coordinate-space-transform-widget\n  input[data-is-valid=\"false\"]::placeholder {\n  text-decoration: solid underline red;\n}\n\n.neuroglancer-coordinate-space-transform-output-extend {\n  grid-row: outputDim -1;\n  grid-column: outputNames;\n  display: flex;\n  flex-direction: column;\n}\n\n.neuroglancer-coordinate-space-transform-output-extend input {\n  align-self: stretch;\n}\n\n.neuroglancer-coordinate-space-transform-output-extend[data-is-active=\"false\"]\n  input {\n  display: none;\n}\n\n.neuroglancer-coordinate-space-transform-output-extend[data-is-active=\"true\"]\n  .neuroglancer-icon {\n  display: none;\n}\n\n.neuroglancer-coordinate-space-transform-output-extend .neuroglancer-icon {\n  align-self: start;\n}\n\n.neuroglancer-coordinate-space-transform-translation-coeff {\n  margin-left: 3px;\n}\n\n.neuroglancer-coordinate-space-transform-output-scale-container {\n  margin-right: 3px;\n}\n\n.neuroglancer-coordinate-space-transform-input-scale-container,\n.neuroglancer-coordinate-space-transform-input-scale-label {\n  margin-bottom: 3px;\n}\n\n.neuroglancer-coordinate-space-transform-widget input,\n.neuroglancer-coordinate-space-transform-output-name-container,\n.neuroglancer-coordinate-space-transform-scale-container {\n  border: 1px solid #333;\n}\n\n.neuroglancer-coordinate-space-transform-widget\n  .neuroglancer-coordinate-space-transform-output-name,\n.neuroglancer-coordinate-space-transform-widget\n  .neuroglancer-coordinate-space-transform-scale {\n  border: 0px;\n}\n\n.neuroglancer-coordinate-space-transform-output-name-container {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-right: 3px;\n}\n\n.neuroglancer-coordinate-space-transform-scale-container {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.neuroglancer-coordinate-space-transform-scale-suggestion {\n  font-family: monospace;\n  cursor: pointer;\n  border-radius: 20%;\n  border: 1px solid #333;\n  align-self: flex-end;\n  margin: 2px;\n  color: #aaa;\n}\n\n.neuroglancer-coordinate-space-transform-scale-suggestion svg {\n  width: 16px;\n  height: 16px;\n  fill: transparent;\n  stroke: #aaa;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.neuroglancer-coordinate-space-transform-scale-suggestion:hover {\n  background-color: #db4437;\n  border: 1px solid transparent;\n  color: white;\n}\n\n.neuroglancer-coordinate-space-transform-scale-suggestion:hover svg {\n  stroke: white;\n}\n\n.neuroglancer-coordinate-space-transform-widget-reset-buttons {\n  grid-row: outputDim -1;\n  grid-column: headerEnd / -1;\n  justify-self: start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
